import styles from './ErrorLabel.module.scss';
import { Caption } from '@components';

type TProps = {
	hasError: boolean;
	errorMessage: string | JSX.Element;
	textColor?: string;
	noErrorNoContainer?: boolean;
}

export const ErrorLabel = (props:TProps) => {
	const {
		hasError,
		errorMessage,
		textColor = 'var(--txt-error)',
		noErrorNoContainer = false
	} = props;
	return (
		<>
			{noErrorNoContainer && hasError && <Caption color={textColor}>{errorMessage}</Caption>}
			{!noErrorNoContainer && <div data-testid={'@Ofload-ErrorLabel'} className={noErrorNoContainer ? '' : styles.errorMsgContainer}>
				{hasError && <Caption color={textColor}>{errorMessage}</Caption>}
			</div>}
		</>
	);
}
